import React from 'react';
import Editor from './Editor';

interface InputCommentProps {
  onChange?: (value: string) => void;
  value: string;
  readonly?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  shadow?: boolean;
}

const InputComment: React.FC<InputCommentProps> = ({
  onChange,
  value,
  readonly,
  onKeyDown,
  shadow = false 
}) => {
  return (
    <Editor
      shadow={shadow}
      value={value}
      onChange={onChange}
      readonly={readonly}
      onKeyDown={onKeyDown}
    />
  )
}

export default InputComment;


